// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-cell-group{background-color:#fff}.van-cell-group__title{padding:2.133vw 2.133vw 1.067vw;color:#969799;font-size:1.867vw;line-height:2.133vw}", ""]);
// Exports
module.exports = exports;
